import { Entity, Field } from "typegraph";

import { ICountResult } from "common/entities/organizationWrapper/OrganizationWrapper";

@Entity({one: "countResult", many: "countResults"})
export default class CountResult implements ICountResult {

	@Field()
	public count: number;

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/stats/entities/CountResult.ts